import { render, staticRenderFns } from "./Vocab.vue?vue&type=template&id=1853cbe0"
import script from "./Vocab.vue?vue&type=script&lang=js"
export * from "./Vocab.vue?vue&type=script&lang=js"
import style0 from "./Vocab.vue?vue&type=style&index=0&id=1853cbe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports